import React from 'react'
import styled from 'styled-components'
import { Image as UnstyledImage, Modal } from 'semantic-ui-react'
import { Card, CardContent, CardGroup } from 'components/Card'

import { Loader } from 'shared/components/Loader'
import { widgetLabelMap } from 'components/Admin/FeedbackWidgetSettings'
import './styles.css'

const widgetTypeSelectors = [
  {
    type: 'grid',
    image: 'https://cdn.simplesat.io/images/widget/grid-prototype.jpg',
  },
  {
    type: 'masonry',
    image: 'https://cdn.simplesat.io/images/widget/masonry-prototype.jpg',
  },
  {
    type: 'score',
    image: 'https://cdn.simplesat.io/images/widget/score-prototype.jpg',
  },
  {
    type: 'popup_box',
    image: 'https://cdn.simplesat.io/images/widget/popup-box-prototype.jpg',
  },
  {
    type: 'carousel',
    image: 'https://cdn.simplesat.io/images/widget/carousel-prototype.jpg',
  },
]
export default function CreateWidgetModal({ createWidget, createWidgetAPILoading }) {
  return (
    <React.Fragment>
      {createWidgetAPILoading && <Loader className="!z-10" />}
      <Modal.Header>Create a new feedback widget</Modal.Header>
      <Modal.Content>
        <CardGroup itemsPerRow={3} doubling>
          {widgetTypeSelectors.map((widget) => (
            <WidgetTypeSelectorCard
              key={widget.type}
              image={widget.image}
              type={widget.type}
              createWidget={() => createWidget(widget.type)}
            />
          ))}
        </CardGroup>
      </Modal.Content>
    </React.Fragment>
  )
}

const Image = styled(UnstyledImage)`
  padding: 1rem !important;
`

function WidgetTypeSelectorCard({ type, image, createWidget }) {
  return (
    <Card onClick={createWidget}>
      <Image src={image} wrapped ui={false} className="ss-widget-type-card-image" />
      <CardContent>
        <h3 className="text-black">{widgetLabelMap[type]}</h3>
      </CardContent>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CreateWidgetModal/index.js